import type { DemoKey } from './keys';

export const it: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Geometria · 3D',
  'panel.figure': 'Figura',
  'panel.dims': 'Dimensioni',
  'panel.style': 'Aspetto',
  'panel.lines': 'Linee speciali',
  'style.body': 'Corpo',
  'style.line': 'Linea',
  'style.cut': 'Sezione',
  'style.labels': 'Etichette vertici',
  'group.face': 'Diagonali delle facce / generatrici',
  'group.space': 'Diagonali / assi / mediane',
  'split.label': 'Sezione',
  'btn.animate': 'Anima',
  'btn.reset': 'Ripristina',
  'hint.line1': 'Trascina per ruotare · Scorri per zoomare',
  'hint.line2': 'Clicca una linea per selezionarla',
  'fig.cuboid': 'Parallelepipedo',
  'fig.cube': 'Cubo',
  'fig.triPrism': 'Prisma triangolare',
  'fig.hexPrism': 'Prisma esagonale',
  'fig.tetrahedron': 'Tetraedro',
  'fig.squarePyramid': 'Piramide quadrata',
  'fig.cylinder': 'Cilindro',
  'fig.cone': 'Cono',
  'fig.sphere': 'Sfera',
  'fig.frustumPyramid': 'Tronco di piramide',
  'fig.frustumCone': 'Tronco di cono',
  'dim.length': 'lunghezza',
  'dim.width': 'larghezza',
  'dim.height': 'altezza',
  'dim.side': 'lato',
  'dim.radius': 'raggio',
  'dim.r1': 'raggio inferiore',
  'dim.r2': 'raggio superiore',
  'dim.sideBase': 'lato base',
  'dim.sideTop': 'lato superiore',
  'info.face': 'faccia',
  'info.center': 'per il centro',
  'info.diagonal': 'diagonale',
  'info.axial': 'diagonale assiale',
  'info.diameter': 'diametro',
  'info.generator': 'generatrice',
  'info.axis': 'asse',
  'info.height': 'altezza',
  'info.median': 'mediana',
  'info.apothem': 'apotema',
  'info.diameterBase': 'diametro base',
  'info.diameterTop': 'diametro superiore',
};
